/** Workspace path shown in Fleet Control when Self improvement is toggled. */
export function resolveDisplayedChatWorkspacePath(params: {
  selfImprovement: boolean;
  repoWorkspace: string | null | undefined;
  sessionWorkspace: string | null | undefined;
}): string | null {
  const repo = params.repoWorkspace?.trim();
  if (params.selfImprovement && repo) {
    return repo;
  }
  const session = params.sessionWorkspace?.trim();
  return session || null;
}

export function selfImprovementWorkspaceHint(params: {
  selfImprovement: boolean;
  repoWorkspace: string | null | undefined;
  sessionWorkspace: string | null | undefined;
}): string | null {
  if (!params.selfImprovement) {
    return null;
  }
  const repo = params.repoWorkspace?.trim();
  const session = params.sessionWorkspace?.trim();
  if (!repo) {
    return "Self improvement: resolving worker repository path…";
  }
  if (session && repo !== session) {
    return `Self improvement will edit the git checkout at ${repo} (this chat’s session files stay under ${session}).`;
  }
  return `Self improvement will edit the git checkout at ${repo}.`;
}
